<template>
  <div class="iframe">
    <fixed-header></fixed-header>
    <iframe v-if="showIframe" :src="link" class="iframe__main scroll-touch"></iframe>
  </div>
</template>
<script>
import FixedHeader from 'components/common/FixedHeader';

export default {
  components: { FixedHeader },
  data() {
    const { link } = this.$route.query;
    return {
      link: decodeURIComponent(link),
    };
  },
  computed: {
    showIframe() {
      const { link } = this;
      return link.indexOf('lingxi.mgtv.com/shop') === -1;
    },
  },
  created() {
    if (!this.showIframe) { // 如果是电商的页面
      this.splitUrl();
    }
  },
  methods: {
    splitUrl() {
      const val = this.link.split('#')[1];
      this.$router.replace(val);
    },
  },
};

</script>
<style lang="scss" scoped>
.iframe {
  height: 100%;
  box-sizing: border-box;

  &__main {
    height: 100%;
    width: 100%;
    border: none;
  }
}
</style>
